import React, { Component } from 'react';
import {Table, Button, Input} from 'semantic-ui-react'
import {DateTimeInput} from 'semantic-ui-calendar-react'
import AdminApi from '../../utils/AdminApi'



class RoundRow extends Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      open: false,
      target_reads: '',
      deadline: '',
      id: ''
    }

    this.handleOpen = this.handleOpen.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }  
  
  toggleRow(e) {
    console.log('toggleRow');
    this.setState({open: !this.state.open});
  }
  /*onClick={this.toggleRow.bind(this)} className={classes}>   <RoundRowExpanded open={this.state.open}/>*/
    
  handleChange(event, {name, value}){
    if (this.state.hasOwnProperty(name)) {
      this.setState({ [name]: value });
    }
  }

  handleOpen(){
    this.setState({
      open: !this.state.open,
      target_reads: this.props.data.target_reads,
      deadline: this.props.data.deadline,
      id: this.props.data.id
    })
    
  }
  
  handleSubmit(event){
    AdminApi.editRound(this.state)
    .then(response => {
      window.location.reload()
    })

    this.handleOpen()
  }

  render(){
    
    let short_data = {
        round: this.props.data.round_number,
        progress: this.props.data.num_graded + '/' + this.props.data.total_reads_needed,
        total_apps: this.props.data.num_apps,
        grader_target: this.props.data.grader_target,
        target_reads: this.props.data.target_reads,
        deadline: this.props.data.deadline
      }
    
    let uneditable = Object.values(short_data).map((item, idx) => 
      <Table.Cell key={item+"-"+idx}>{item}</Table.Cell>
    )
    uneditable.push(
      <Table.Cell key={'Edit'}><Button onClick={this.handleOpen}>Edit</Button></Table.Cell>
    )

    let editable = uneditable.slice(0,4)
    editable.push([
      <Table.Cell key={short_data.target_reads}><Input type="text" name='target_reads' value={this.state.target_reads} onChange={this.handleChange}/></Table.Cell>,
      <Table.Cell key={short_data.deadline}>
        <DateTimeInput name="deadline" placeholder="Date Time" value={this.state.deadline} iconPosition="left" onChange={this.handleChange} /> 
      </Table.Cell>,
      <Table.Cell key={'Submit'}>
        <Button.Group>
          <Button onClick={this.handleOpen}>Cancel</Button>
          <Button.Or />
          <Button positive onClick={this.handleSubmit}>Save</Button>
        </Button.Group>
      </Table.Cell>
    ])
    let children = this.state.open ? editable : uneditable;
    return(
      <Table.Row className={this.props.hl} children={children}></Table.Row>
    )
  }
  
};

export default RoundRow



       


// WEBPACK FOOTER //
// ./src/components/admin/rounds_table/RoundRow.js